import { sprintf } from 'sprintf-js'

const cipherTable = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'

export function decodeBoatClass(code: string): number | null {
    // Validate input length 1-2 and not empty
    if (code == null)
        return null

    // If numeric from 0 to 99, return as number directly
    if (/^\d{1,2}$/.test(code))
        return parseInt(code)

    // If contains non-allowed characters or length invalid, return null
    if (code.length === 0 || code.length > 2)
        return null

    const chars = Array.from(code)
    const i1 = cipherTable.indexOf(chars[0])
    const i2 = code.length === 2 ? cipherTable.indexOf(chars[1]) : cipherTable.indexOf('0')

    if (i1 < 0 || (code.length === 2 && i2 < 0))
        return null

    // Pad to two characters (left pad) if needed
    if (code.length < 2)
        code = sprintf('%02s', code)

    const c = Array.from(code)
    const a = cipherTable.indexOf(c[0])
    const b = cipherTable.indexOf(c[1])

    if (a < 0 || b < 0)
        return null

    return 1000 + a * 100 + b
}

export function encodeBoatClass(code: number): string | null {
    // code must be non-negative
    if (code == null || code < 0)
        return null

    if (code < 1000)
        return sprintf('%02d', code)

    code -= 1000

    const first = Math.trunc(code / 100)
    const second = code % 100

    const f = cipherTable.charAt(first)
    const s = cipherTable.charAt(second)

    // If indices out of bounds, charAt returns '' which is not in cipherTable
    if (f === '' || s === '')
        return null

    // Ensure both are in cipherTable explicitly
    if (cipherTable.indexOf(f) < 0 || cipherTable.indexOf(s) < 0)
        return null

    return f + s
}
